"use client";

import { FeatureTour } from "@/_components/ui/FeatureTours/constant";
import { usePathname } from "next/navigation";
import { useNextStep } from "nextstepjs";
import { useCallback, useEffect, useState } from "react";

const ONBOARDING_NEWBIE_KEY = "onboarding_newbie_completed";

const getInitialOnboardingState = (): boolean => {
  if (typeof window === "undefined") return true;

  try {
    return localStorage.getItem(ONBOARDING_NEWBIE_KEY) !== "true";
  } catch {
    return true;
  }
};

export const useOnboardingNewbie = () => {
  const pathname = usePathname();
  const { startNextStep } = useNextStep();
  const [shouldShowOnboarding, setShouldShowOnboarding] = useState<boolean>(
    getInitialOnboardingState,
  );

  useEffect(() => {
    const isDashboardRoute = pathname?.endsWith("/dashboard");
    if (!isDashboardRoute || !shouldShowOnboarding) return;

    const timer = setTimeout(() => {
      startNextStep(FeatureTour.Onboarding);
    }, 1000);

    return () => clearTimeout(timer);
  }, [pathname, shouldShowOnboarding, startNextStep]);

  const completeOnboarding = useCallback(() => {
    try {
      localStorage.setItem(ONBOARDING_NEWBIE_KEY, "true");
    } catch {
      return;
    }
    setShouldShowOnboarding(false);
  }, []);

  return {
    shouldShowOnboarding,
    completeOnboarding,
  };
};
